"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _minus = _interopRequireDefault(require("cccisd-icons/minus3"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus3"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var NumberPicker = function NumberPicker(_ref) {
  var onChange = _ref.onChange,
    name = _ref.name,
    value = _ref.value,
    className = _ref.className;
  // need to use it's length property
  if (!Number.isNaN(value)) {
    value += '';
  }
  function handleChange(val) {
    // positive whole numbers only
    if (val && /[^0-9]/.test(val)) {
      return;
    }
    val = parseInt(val, 10);
    onChange(val);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style["default"].numberPicker, " ").concat(className)
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: function onClick() {
      return handleChange(parseInt(value, 10) - 1);
    }
  }, /*#__PURE__*/_react["default"].createElement(_minus["default"], null)), /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    value: value,
    onChange: function onChange(event) {
      return handleChange(event.currentTarget.value);
    },
    name: name,
    style: {
      width: "".concat(value.length * 0.66, "em")
    },
    onBlur: function onBlur(event) {
      if (event.currentTarget.value === '') {
        handleChange('0');
      }
    }
  }), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: function onClick() {
      return handleChange(parseInt(value, 10) + 1);
    }
  }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null)));
};
NumberPicker.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  value: _propTypes["default"].number.isRequired,
  name: _propTypes["default"].string,
  className: _propTypes["default"].string
};
NumberPicker.defaultProps = {
  className: ''
};
var _default = exports["default"] = NumberPicker;